import { useEffect, useState, useCallback } from 'react';
import { getHoursMatrix, updateHoursMatrix } from '../../services/pricing/hoursMatrix.service.js';

export const useHoursMatrix = () => {
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [loading, setLoading] = useState(true);

    // Alert confirmación
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        message: '',
        icon: null,
        onConfirm: null
    });
    // Error
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    // Success
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    // DATA
    const fetchMatrix = useCallback(async () => {
        try {
            setLoading(true);
            const result = await getHoursMatrix();
            setData(result);
            setOriginalData(JSON.parse(JSON.stringify(result)));
        } catch {
            setErrorMessage('Error cargando la matriz de horas.');
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMatrix();
    }, [fetchMatrix]);

    // EDICIÓN LOCAL
    const updateLocalValue = (id, value) => {
        setData(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, hours_man: Number(value) }
                    : row
            )
        );
    };

    const hasChanges = JSON.stringify(data) !== JSON.stringify(originalData);

    // GUARDAR
    const saveChanges = async () => {
        try {
            const updates = data.filter((row, i) =>
                row.hours_man !== originalData[i].hours_man
            );

            for (const row of updates) {
                await updateHoursMatrix(row.id, row.hours_man);
            }

            setOriginalData(JSON.parse(JSON.stringify(data)));
            setSuccessMessage('La matriz de horas fue actualizada correctamente.');
            setShowSuccessModal(true);
        } catch {
            setErrorMessage('Error guardando los cambios.');
            setShowErrorModal(true);
        }
    };

    // CONFIRMAR HABILITAR EDICIÓN
    const askEnableEdit = (onConfirm) => {
        setAlertConfig({
            title: 'Habilitar edición',
            message: '¿Deseas habilitar la edición de la matriz de horas?',
            icon: '⚠️',
            onConfirm
        });
        setShowAlertModal(true);
    };

    return {
        data,
        loading,
        // edición
        updateLocalValue,
        saveChanges,
        hasChanges,
        // alert modal
        showAlertModal,
        alertConfig,
        askEnableEdit,
        closeAlertModal: () => setShowAlertModal(false),
        // error modal
        showErrorModal,
        errorMessage,
        closeErrorModal: () => setShowErrorModal(false),
        // success modal
        showSuccessModal,
        successMessage,
        closeSuccessModal: () => setShowSuccessModal(false)
    };
};